module.exports = __webpack_public_path__ + "img/reg-l.70a5ab79.png";